<template>
  <v-card class="dialog">
    <v-card-title class="primary">
      <h2 class="titulo-modal-erro-chassi-existente" style="padding-left: 16px">
        ERRO PARA {{ textoSalvarOuEmitir }} COTAÇÃO
      </h2>
    </v-card-title>

    <div>
      <v-card-text flex>
        <v-card class="pa-0" style="background: none" flat>
          <v-card-text tex class="scroll-container text-xs-center" style="max-height: 150px; overflow-y: auto;">
            <h3 style="color: red; font-weight: 500; font-size: 16px; font-family:'Roboto Medium', 'Roboto Regular', 'Roboto', sans-serif;">
              {{ mensagemErro }}
            </h3>
          </v-card-text>
        </v-card>

        <v-card-actions class="pt-4">
          <v-layout row>
            <v-flex xs12 md4F class="justify-content-right">
              <v-btn style="font-weight: 500" class="button-custom" flat @click="fecharModalErroChassiExistente()">
                FECHAR
              </v-btn>
              <v-btn
                v-if="mostrarBotaoSalvarOuEmitir"
                :disabled="loading"
                class="button-import-errors error"
                flat
                color="error"
                @click="emitirOuSalvarPropostaComErros()"
                style="color: white!important;"
                >{{ textoSalvarOuEmitir }} COM ERROS
              </v-btn>
            </v-flex>
          </v-layout>
          
        </v-card-actions>
      </v-card-text>
    </div>
  </v-card>
</template>
<script>
  export default {
    name: "ModalErroChassiExistente",
    props: {
      mensagemErro: String,
      textoSalvarOuEmitir: String,
      mostrarBotaoSalvarOuEmitir: Boolean
    },
    methods: {
      fecharModalErroChassiExistente() {
        this.$emit("fecharModalErroChassiExistente");
      },
      emitirOuSalvarPropostaComErros() {
        this.$emit("fecharModalErroChassiExistente");
        this.$emit("emitirOuSalvarPropostaComErros");
      }
    }
  };
</script>

<style>
  .dialog {
    background: #eaeaea !important;
  }

  .titulo-modal-erro-chassi-existente {
    color: #fff !important;
    font-size: 25px !important;
    font-weight: 400;
  }

  .click {
    cursor: pointer;
  }

  .justify-content-right {
    display: flex !important;
    justify-content: right !important;
  }

  .button-import-errors {
    width: 100%;
    max-width: 175px;
    text-align: center;
    color: #fff !important;
    background-color: #00456e;
    border-radius: 2px;
    display: inline-block;
    padding: 9px 12px;
    cursor: pointer;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/frota/ModalErroChassiExistente.vue